import { useCallback, useEffect, useState } from "react";

import IFormAssistitoProps from "pages/Prenotazione/Form/Assistito/FormAssistito/IFormAssistitoProps";

import { GeneralRepository } from "core/data/index";

import { IOption } from "core/interfaces/data/IOption";
import { ICittadinanza, IComune, ILegameUtente, IMunicipio } from "core/interfaces/data/IGeneralRequest";

import { DatePicker, Input, Radio, Space, Form, Select, Checkbox, Spin } from "antd";
import { CustomButton, CustomRadio, HrText, RemoteSelect, Label } from "core/interfaces/components/index";

import { validateCf, validateCfVsFormData, validateExixtsAssistedCf } from "utils/Validate";

import "./FormAssistito.css";
import moment, { Moment } from "moment";
import { FaChevronLeft } from "react-icons/fa";
import { getDatiUtenteFromCF } from "utils/Helper";
import { notifyValidationError } from "components/NotificaValidazioneFallita/NotificaValidazioneFallita";
import _ from "lodash";

import { IAssistito, IFamiliare } from "core/interfaces/data/IAssistitoRequest";
import AssistedPrivacyAutorizations from "components/AssistedPrivacyAutorizations/AssistedPrivacyAutorizations";
import { CustomButtonType } from "components/CustomButton/CustomButtonType";
import Riepilogo from "components/Riepilogo/Riepilogo";
import { useErrorHandler } from "react-error-boundary";
import { performAsyncFunction } from "utils/AsyncFunctionUtility";
import { DefaultOptionType } from "antd/lib/select";
import { setIndirizzo, setLuogoErogazione } from "core/redux/features/dataForm/dataFormSlice";
import { ILuogoErogazione } from "core/interfaces/data/ILuogoErogazione";
import { IValidateCfVsFormData } from "core/interfaces/util/IValidators";
import { Enhanced } from "utils/ReactUtils";
import dayjs from "dayjs";

const { Option } = Select;

interface IAssistitoFormData extends Omit<IAssistito, "ComuneNascita" | "ComuneResidenza" | "ComuneDomicilio" | "IdCittadinanza" | "DataNascita"> {
	ComuneNascita: IOption | undefined;
	ComuneResidenza: IOption;
	ComuneDomicilio: IOption;
	CodiceCittadinanza: IOption | undefined;
	CapComuneNascita: string | undefined;
	CapComuneResidenza: string;
	CapComuneDomicilio: string;
	DataNascita: Moment;
}

const FormAssistito: React.FC<IFormAssistitoProps> = ({ perFamiliare, OnSubmit, Back, dataForm, sessionInfo, t, i18n, dispatch }) => {
	const [isFirstLoad, setIsFirstLoad] = useState<boolean>(true);

	const [comuneNascita, setComuneNascita] = useState<IOption>();
	const [cittadinanza, setCittadinanza] = useState<IOption>();

	// const [needCapNascita, setNeedCapNascita] = useState<boolean>(false);
	const [comuneDomicilio, setComuneDomicilio] = useState<IOption>();
	const [comuneDomicilioDefaultDataSource, setComuneDomicilioDefaultDataSource] = useState<IOption[]>();

	const [needCapDomicilio, setNeedCapDomicilio] = useState<boolean>(false);
	const [comuneResidenza, setComuneResidenza] = useState<IOption>();
	const [needCapResidenza, setNeedCapResidenza] = useState<boolean>(false);

	const [municipiDomicilio, setMunicipiDomicilio] = useState<IMunicipio[]>([]);
	const [needMunicipioDomicilio, setNeedMunicipioDomicilio] = useState<boolean>(false);
	const [comuneDomicilioLocked, setComuneDomicilioLocked] = useState<boolean>(false);

	const [municipiResidenza, setMunicipiResidenza] = useState<IMunicipio[]>([]);
	const [legamiUtente, setLegamiUtente] = useState<ILegameUtente[]>([]);
	const [needMunicipioResidenza, setNeedMunicipioResidenza] = useState<boolean>(false);

	const [coincideDomicilio, setCoincideDomicilio] = useState<boolean>(false);

	const [spinning, setSpinning] = useState<boolean>(false);

	const [form] = Form.useForm();

	const handleError = useErrorHandler();

	const getComuni = useCallback(
		async (comune: string, valido?: boolean, codiceIstat?: string, cap?: string): Promise<IComune[] | undefined> => {
			const comuni = await GeneralRepository.getComuni({
				Comune: comune,
				CodiceIstat: codiceIstat,
				Cap: cap,
				culture: i18n.language,
				Validi: valido,
			});

			return comuni;
		},
		[i18n.language]
	);

	const getMunicipi = useCallback(
		async (codIstat: string): Promise<IMunicipio[] | undefined> => {
			const municipiFetched = await GeneralRepository.getMunicipi({
				CodiceIstat: codIstat,
				culture: i18n.language,
			});

			return municipiFetched;
		},
		[i18n.language]
	);

	const getCittadinanze = async (cittadinanza: string): Promise<ICittadinanza[] | undefined> => {
		const cittadinanzeFetched = await GeneralRepository.getCittadinanze({
			Descrizione: cittadinanza,
			culture: i18n.language,
		});

		return cittadinanzeFetched;
	};

	const fetchComuneNascita = async (comune: string): Promise<IOption[]> => {
		const comuni = await getComuni(comune, false);

		if (comuni) {
			return comuni.map((comune, index) => ({ label: `${comune.Descrizione} (${comune.Provincia})`, value: comune.CodIstat, key: index }));
		}

		return [];
	};

	const fetchComuniDomicilio = async (comune: string): Promise<IOption[]> => {
		var cap = dataForm.area?.LuogoErogazione?.CAP;

		const comuni = await getComuni(comune, undefined, undefined, cap);

		if (comuni) {
			return comuni.map((comune, index) => ({ label: `${comune.Descrizione} (${comune.Provincia})`, value: comune.CodIstat, key: index }));
		}

		return [];
	};

	const fetchComuniResidenza = async (comune: string): Promise<IOption[]> => {
		const comuni = await getComuni(comune, undefined);

		if (comuni) {
			return comuni.map((comune, index) => ({ label: `${comune.Descrizione} (${comune.Provincia})`, value: comune.CodIstat, key: index }));
		}

		return [];
	};

	const fetchCittadinanze = async (cittadinanza: string): Promise<IOption[]> => {
		if (!cittadinanza.isNullOrWhiteSpaces()) {
			const cittadinanze = await getCittadinanze(cittadinanza);

			if (cittadinanze) {
				return cittadinanze.map((cittadinanza, index) => mapCittadinanza(cittadinanza));
			}
		}
		return [];
	};

	const mapCittadinanza = (cittadinanza: ICittadinanza) => {
		return { label: cittadinanza.Descrizione, value: cittadinanza.ID, key: cittadinanza.Code };
	};

	const OnSubmitForm = async (data: IAssistitoFormData) => {
		let comuni;
		let comuneResidenza: IComune;
		let comuneNascita: IComune | undefined = undefined;
		let comuneDomicilio: IComune;

		const comuneNascitaSelected: IOption| undefined = data.ComuneNascita ;
		const comuneResidenzaSelected: IOption| undefined = data.ComuneResidenza ;
		const comuneDomicilioSelected: IOption| undefined = data.ComuneDomicilio ;

		if (comuneNascitaSelected) {
			comuni = await getComuni(comuneNascitaSelected.label.substring(0, comuneNascitaSelected.label.indexOf(" (")), false);

			if (comuni) {
				comuneNascita = comuni.filter((comune) => comune.CodIstat === comuneNascitaSelected.value)[0];

				comuneNascita.CAP = data.CapComuneNascita ?? "";
			}
		}

		comuni = await getComuni(comuneDomicilioSelected.label.substring(0, comuneDomicilioSelected.label.indexOf(" (")));

		if (comuni) {
			comuneDomicilio = comuni.filter((comune) => comune.CodIstat === comuneDomicilioSelected.value)[0];

			comuneDomicilio.CAP = data.CapComuneDomicilio;

			if (!coincideDomicilio) {
				comuneResidenza = comuneDomicilio;
				data.IndirizzoResidenza = data.IndirizzoDomicilio;
				data.IndirizzoResidenzaDettagli = data.IndirizzoDomicilioDettagli;
				data.MunicipioResidenza = data.MunicipioDomicilio;
			} else {
				comuni = await getComuni(comuneResidenzaSelected.label.substring(0, comuneResidenzaSelected.label.indexOf(" (")));

				if (comuni) {
					comuneResidenza = comuni.filter((comune) => comune.CodIstat === comuneResidenzaSelected.value)[0];

					comuneResidenza.CAP = data.CapComuneResidenza;
				}
			}

			setSpinning(true);

			let resdata: IAssistito = {
				Nome: data.Nome,
				Cognome: data.Cognome,
				CodiceFiscale: data.CodiceFiscale,
				Sesso: data.Sesso,
				DataNascita: data.DataNascita?.toDate().toWSDateFormat(),
				ComuneNascita: comuneNascita,
				TelefonoContatti: data.TelefonoContatti,
				IndirizzoDomicilio: data.IndirizzoDomicilio,
				IndirizzoResidenza: data.IndirizzoResidenza,
				IndirizzoResidenzaDettagli: data.IndirizzoResidenzaDettagli,
				IndirizzoDomicilioDettagli: data.IndirizzoDomicilioDettagli,
				TelefonoResidenza: data.TelefonoResidenza,

				ComuneResidenza: comuneResidenza!,
				ComuneDomicilio: comuneDomicilio,
				MunicipioResidenza: data.MunicipioResidenza,
				MunicipioDomicilio: data.MunicipioDomicilio,
				TelefonoDomicilio: data.TelefonoDomicilio,
				LegameUtente: data.LegameUtente,

				Privacy: data.Privacy,
				Terzi: data.Terzi,
				ComunicazioniMMG: data.ComunicazioniMMG,
				ComunicazioniServizio: data.ComunicazioniServizio,
				DocSanitari: data.DocSanitari,
				Marketing: data.Marketing,
				IdCittadinanza: data.CodiceCittadinanza?.value as number,
			};

			var luogoErigazione: ILuogoErogazione = {
				CAP: comuneDomicilio.CAP,
				Civico: "",
				CAPMultipli: false,
				Via: `${data.IndirizzoDomicilio} ${data.IndirizzoDomicilioDettagli ?? ""}`,
				Comune: comuneDomicilio.Descrizione,
				Provincia: comuneDomicilio.Provincia,
				CodIstat: comuneDomicilio.CodIstat,
			};

			if (!dataForm.area?.LuogoErogazione?.CodIstat) {
				dispatch(setLuogoErogazione(luogoErigazione));
			} else {
				dispatch(setIndirizzo(luogoErigazione.Via!));
			}

			OnSubmit(resdata);
		}
	};

	const OnSelectComuneDomicilio = useCallback(
		async (value: IOption | undefined) => {
			form.setFieldsValue({
				CapComuneDomicilio: "",
			});

			setComuneDomicilio(value);
			setNeedMunicipioDomicilio(false);
			setNeedCapDomicilio(false);
			if (value) {
				const comuni = await getComuni(
					value.label.substring(0, value.label.indexOf(" (")),
					true,
					value.value.toString(),
					dataForm.area?.LuogoErogazione?.CAP
				);

				if (comuni) {
					const comune = comuni.filter((comune) => comune.CodIstat === value.value)[0];

					if (comune.CAP === null || comune.CAP === "") {
						setNeedCapDomicilio(true);
					} else {
						form.setFieldsValue({
							CapComuneDomicilio: comune.CAP,
						});
					}

					const municipiComune = await getMunicipi(comune.CodIstat);

					if (municipiComune && municipiComune.length !== 0) {
						setNeedMunicipioDomicilio(true);
						setMunicipiDomicilio(municipiComune);
					}
				}
			}
		},
		[dataForm.area?.LuogoErogazione?.CAP, form, getComuni, getMunicipi]
	);

	const OnSelectComuneResidenza = async (value: IOption) => {
		form.setFieldsValue({
			CapComuneResidenza: "",
		});

		setComuneResidenza(value);
		setNeedMunicipioResidenza(false);
		setNeedCapResidenza(false);

		const comuni = await getComuni(value.label.substring(0, value.label.indexOf(" (")));
		if (value) {
			if (comuni) {
				const comune = comuni.filter((comune) => comune.CodIstat === value.value)[0];

				if (comune.CAP === null || comune.CAP === "") {
					setNeedCapResidenza(true);
				} else {
					form.setFieldsValue({
						CapComuneResidenza: comune.CAP,
					});
				}

				const municipiComune = await getMunicipi(comune.CodIstat);

				if (municipiComune && municipiComune.length !== 0) {
					setNeedMunicipioResidenza(true);
					setMunicipiResidenza(municipiComune);
				}
			}
		}
	};

	const OnFinishFailed = (e: any) => {
		const input = document.querySelector(`#${e.errorFields[0].name[0]}`);

		if (input) {
			input.scrollIntoView({
				behavior: "smooth",
				block: "start",
				inline: "start",
			});
		}

		const errors = e.errorFields;

		let notifica = {
			Title: t("assistito.requiredMessages.notifica.titolo"),
			Message: new Array<string>(),
		};
		_.each(errors, (err, index: number) => {
			notifica.Message.push(t("assistito.requiredMessages.notifica." + err.name[0]));
		});

		notifyValidationError(notifica.Title, notifica.Message);
	};

	const comuneOption = (comune: IComune, index: number): IOption => {
		let res: IOption = { label: `${comune.Descrizione} (${comune.Provincia})`, value: comune.CodIstat, key: index };
		return res;
	};

	const OnChangeCodiceFiscale = useCallback(
		async (props: any) => {
			let cf = props?.target?.value !== undefined ? props?.target?.value : form.getFieldValue("CodiceFiscale");

			let res = await getDatiUtenteFromCF(cf);

			if (res) {
				var cittadinanza: IOption | undefined = undefined;
				if (res && res?.cittadinanza) {
					cittadinanza = mapCittadinanza(res.cittadinanza);
				}

				form.setFieldsValue({
					Sesso: res.sesso,
					DataNascita: res?.dataNascita!==undefined ? dayjs(res?.dataNascita) : undefined,
					// DataNascita: moment(res.dataNascita, "DD/MM/YYY", true),
					ComuneNascita: res && res?.comune ? comuneOption(res?.comune, res?.comune.ID) : undefined,
					CodiceCittadinanza: cittadinanza,
				});

				setComuneNascita(res && res?.comune ? comuneOption(res?.comune, res?.comune.ID) : undefined);
				setCittadinanza(cittadinanza);
			}
		},
		[form]
	);

	// const OnChangeDataNascita = (value: any | null, dateString: string) => {
	// 	form.setFieldsValue({
	// 		DataNascita: value,
	// 	});
	// };

	useEffect(() => {
		if (isFirstLoad) {
			setSpinning(true);
			performAsyncFunction(async () => {
				const legamiUtente = await GeneralRepository.getLegamiUtente();
				setLegamiUtente(legamiUtente);

				var luogoErogazione = dataForm.area?.LuogoErogazione;
				if (luogoErogazione) {
					var comuni: IComune[] | undefined;

					comuni = await getComuni(luogoErogazione.Comune, true, luogoErogazione?.CodIstat, luogoErogazione?.CAP);

					setComuneDomicilioDefaultDataSource(
						comuni?.map((c) => {
							return comuneOption(c, c.ID);
						})
					);
					if (comuni?.length === 1) {
						var comune = comuni[0];
						var comOption = comuneOption(comune, comune.ID);
						setComuneDomicilio(comOption);
						OnSelectComuneDomicilio(comOption);
						form.setFieldsValue({
							ComuneDomicilio: comOption,
							IndirizzoDomicilio: luogoErogazione.Via ? `${luogoErogazione.Via} ${luogoErogazione.Civico ?? ""}` : undefined,
							CapComuneDomicilio: luogoErogazione.CAP,
						});

						setComuneDomicilioLocked(true);
					}
					if (perFamiliare && dataForm.destinatarioAssistenza) {
						var destinarario = dataForm.destinatarioAssistenza as IFamiliare;
						form.setFieldsValue({
							Nome: destinarario.Nome,
							Cognome: destinarario.Cognome,
							CodiceFiscale: destinarario.CodiceFiscale,
							Sesso: destinarario.Sesso,
							DataNascita: destinarario.DataNascita,
							LegameUtente: destinarario.LegameUtente,
						});
						await OnChangeCodiceFiscale(undefined);
					}
				}
				setSpinning(false);
			}, handleError);
			setIsFirstLoad(false);
		}
	}, [
		OnChangeCodiceFiscale,
		OnSelectComuneDomicilio,
		dataForm.area?.LuogoErogazione,
		dataForm.destinatarioAssistenza,
		form,
		getComuni,
		handleError,
		isFirstLoad,
		perFamiliare,
	]);

	const getFormForCfvalidation = (): IValidateCfVsFormData => {
		var comuneNascita = form.getFieldValue("ComuneNascita") as IOption;

		var res: IValidateCfVsFormData = {
			Nome: form.getFieldValue("Nome"),
			Cognome: form.getFieldValue("Cognome"),
			DataNascita: form.getFieldValue("DataNascita"),
			IstatComuneNascita: comuneNascita?.value.toString(),
			ComuneNascita: comuneNascita?.label?.split("(")[0]?.trimEnd(),
			Sesso: form.getFieldValue("Sesso"),
		};

		return res;
	};

	return (
		<div id="assistito">
			<div className="title">
				<span>{t("assistito.title")}</span>
			</div>
			<Riepilogo />
			<CustomButton
				text={sessionInfo.isLogged ? t("assistito.backToFamily") : t("assistito.backToRegistration")}
				style={{ width: "100%", marginBottom: "3%" }}
				OnClick={() => Back()}
				icon={<FaChevronLeft />}
				buttonType={CustomButtonType.positive}
			/>

			<Spin spinning={spinning}>
				<Form id="formAssistito" onFinishFailed={OnFinishFailed} onFinish={OnSubmitForm} form={form} initialValues={{ remember: true }}>
					{perFamiliare && (
						<>
							<HrText text={t("assistito.text.datiAssistito")} />
							<div className="anagrafica-assistito">
								<div>
									<Label text={" *" + t("assistito.form.name.name")} />
									<Form.Item name="Nome" rules={[{ required: true, message: t("assistito.requiredMessages.name") }]}>
										<Input placeholder={t("assistito.form.name.placeholder")} size="large" />
									</Form.Item>
								</div>
								<div>
									<Label text={" *" + t("assistito.form.surname.name")} />
									<Form.Item name="Cognome" rules={[{ required: true, message: t("assistito.requiredMessages.surname") }]}>
										<Input placeholder={t("assistito.form.surname.placeholder")} size="large" />
									</Form.Item>
								</div>
								<div>
									<Label text={" *" + t("assistito.form.cf.name")} />
									<Form.Item
										name="CodiceFiscale"
										normalize={(props) => props.toUpperCase()}
										rules={[
											{ required: true, message: t("assistito.requiredMessages.cf") },
											{ validator: (rule: any, value: any, callback: any) => validateCf(rule, value, callback, t("register.validationMessages.cf")) },
											{
												validator: (rule: any, value: any, callback: any) =>
													validateExixtsAssistedCf(
														rule,
														value,
														callback,
														t("register.validationMessages.cfFamiliareExists").format(window.CONFIG.REACT_APP_CONTATTI.TELEFONO)
													),
											},
											{
												validator: (rule: any, value: any, callback: any) =>
													validateCfVsFormData(
														rule,
														value,
														callback,
														t("register.validationMessages.cfNotCorresponding").format(window.CONFIG.REACT_APP_CONTATTI.TELEFONO),
														getFormForCfvalidation()
													),
											},
										]}
									>
										<Input maxLength={16} placeholder={t("assistito.form.cf.placeholder")} size="large" onChange={OnChangeCodiceFiscale} />
									</Form.Item>
								</div>
								<div>
									<Label text={" *" + t("assistito.form.sesso.name")} />
									<Form.Item name="Sesso" rules={[{ required: true, message: t("assistito.requiredMessages.sex") }]}>
										<Radio.Group>
											<Space direction="vertical">
												<CustomRadio text={t("assistito.form.sesso.male")} value="M" />
												<CustomRadio text={t("assistito.form.sesso.female")} value="F" />
											</Space>
										</Radio.Group>
									</Form.Item>
								</div>
								<div>
									<Label text={" *" + t("assistito.form.birthday")} />
									<Form.Item name="DataNascita" rules={[{ required: true, message: t("assistito.requiredMessages.birthday"), type: "date" }]}>
										<DatePicker
											disabledDate={(current) => current && current > moment()}
											format="DD/MM/YYYY"
											style={{ width: "100%" }}
											placeholder=""
											// onChange={OnChangeDataNascita}
										/>
									</Form.Item>
								</div>
								<div>
									<Label text={" *" + t("assistito.form.municipality.name")} />
									<Form.Item name="ComuneNascita" rules={[{ required: true, message: t("assistito.requiredMessages.municipality") }]}>
										<RemoteSelect
											allowClear
											placeholder={t("assistito.form.municipality.placeholder")}
											debounceTimeout={20}
											fetchOptions={fetchComuneNascita}
											value={comuneNascita?.value}
											searchValue={comuneNascita?.label}
											OnClear={() => {
												setComuneNascita(undefined);
												form.setFieldsValue({
													ComuneNascita: undefined,
												});
											}}
											OnChange={(newValue, option: any) => {
												form.setFieldsValue({
													ComuneNascita: option,
												});
												setComuneNascita(option);
											}}
										/>
									</Form.Item>
								</div>
								<div>
									<Label text={" *" + t("assistito.form.nationality.name")} />
									<Form.Item name="CodiceCittadinanza" rules={[{ required: true, message: t("assistito.requiredMessages.nationality") }]}>
										<RemoteSelect
											allowClear
											placeholder={t("assistito.form.nationality.placeholder")}
											debounceTimeout={10}
											fetchOptions={fetchCittadinanze}
											value={cittadinanza?.value}
											searchValue={cittadinanza?.label}
											OnClear={() => {
												setCittadinanza(undefined);
												form.setFieldsValue({
													CodiceCittadinanza: undefined,
												});
											}}
											OnChange={(newValue, option: any) => {
												form.setFieldsValue({
													CodiceCittadinanza: option,
												});
												setCittadinanza(option);
											}}
										/>
									</Form.Item>
								</div>

								<div>
									<Label text={" *" + t("assistito.form.legameUtente.name")} />
									<Form.Item name="LegameUtente" rules={[{ required: true, message: t("assistito.requiredMessages.legameUtente") }]}>
										<Select
											placeholder={t("assistito.form.legameUtente.placeholder")}
											showSearch
											filterOption={(input, option) => (option?.label?.toString() ?? "").toLowerCase().includes(input.toLowerCase())}
											options={_.flatMap(legamiUtente, (val) => {
												let res: DefaultOptionType = {
													key: val.Id,
													value: val.Id,
													label: val.Descrizione,
												};

												return res;
											})}
										/>
									</Form.Item>
								</div>
							</div>
						</>
					)}

					<>
						<HrText text={t("assistito.text.indirizzoAssistenza")} />{" "}
						<div className="indirizzo-assistito">
							<div>
								<Label text={" *" + t("assistito.form.addressHome.address.name")} />
								<Form.Item name="IndirizzoDomicilio" rules={[{ required: true, message: t("assistito.requiredMessages.address") }]}>
									<Input placeholder={t("assistito.form.addressHome.address.placeholder")} />
								</Form.Item>
							</div>
							<div>
								<Label text={t("assistito.form.addressHome.home.name")} />
								<Form.Item name="IndirizzoDomicilioDettagli">
									<Input placeholder={t("assistito.form.addressHome.home.placeholder")} />
								</Form.Item>
							</div>
							<div>
								<Label text={" *" + t("assistito.form.addressHome.municipality.name")} />
								<Form.Item name="ComuneDomicilio" rules={[{ required: true, message: t("assistito.requiredMessages.residenceMunicipality") }]}>
									<RemoteSelect
										allowClear
										disabled={comuneDomicilioLocked}
										placeholder={t("assistito.form.addressHome.municipality.placeholder")}
										debounceTimeout={10}
										fetchOptions={fetchComuniDomicilio}
										value={comuneDomicilio?.value}
										searchValue={comuneDomicilio?.label}
										OnClear={() => {
											OnSelectComuneDomicilio(undefined);
										}}
										OnChange={(newValue, option: any) => {
											form.setFieldsValue({
												ComuneDomicilio: option,
											});
											OnSelectComuneDomicilio(option);
										}}
										defaultDatasource={comuneDomicilioDefaultDataSource}
									/>
								</Form.Item>
							</div>
							<div>
								<Label text={" *" + t("assistito.form.CAP.Domicilio")} />
								<Form.Item name="CapComuneDomicilio" rules={[{ required: true, message: t("assistito.requiredMessages.CAP") }]}>
									<Input disabled={!needCapDomicilio || comuneDomicilioLocked} placeholder={t("assistito.form.CAP.Domicilio")} />
								</Form.Item>
							</div>
							{needMunicipioDomicilio && (
								<div>
									<Label text={" *" + t("assistito.form.addressHome.hamlet.name")} />
									<Form.Item name="MunicipioDomicilio" rules={[{ required: true, message: t("assistito.requiredMessages.townHall") }]}>
										<Select placeholder={t("assistito.form.addressHome.hamlet.placeholder")}>
											{municipiDomicilio.map((municipio, index) => {
												return (
													<Option key={index} value={municipio.Value}>
														{municipio.Text}
													</Option>
												);
											})}
										</Select>
									</Form.Item>
								</div>
							)}
						</div>
						<div>
							<Label text={t("assistito.form.phone.name")} />
							<Form.Item name="TelefonoDomicilio">
								<Input placeholder={t("assistito.form.phone.placeholder")} />
							</Form.Item>
						</div>
					</>
					<div className="switch-button-residenza">
						<Checkbox onChange={() => setCoincideDomicilio(!coincideDomicilio)}>{t("assistito.text.residenzaDiversaDomicilio")}</Checkbox>
					</div>

					{coincideDomicilio && (
						<>
							<HrText text={t("assistito.text.residenza")} />

							<div>
								<Label text={" *" + t("assistito.form.addressResidence.address.name")} />
								<Form.Item name="IndirizzoResidenza" rules={[{ required: true, message: t("assistito.message.indirizzoResidenza") }]}>
									<Input placeholder={t("assistito.form.addressResidence.address.placeholder")} />
								</Form.Item>
							</div>
							<div>
								<Label text={t("assistito.form.addressResidence.home.name")} />
								<Form.Item name="IndirizzoResidenzaDettagli">
									<Input placeholder={t("assistito.form.addressResidence.home.placeholder")} />
								</Form.Item>
							</div>
							<div>
								<Label text={" *" + t("assistito.form.addressResidence.municipality.name")} />
								<Form.Item name="ComuneResidenza" rules={[{ required: true, message: t("assistito.message.comuneResidenza") }]}>
									<RemoteSelect
										allowClear
										placeholder={t("assistito.form.addressResidence.municipality.placeholder")}
										debounceTimeout={20}
										fetchOptions={fetchComuniResidenza}
										value={comuneResidenza?.value}
										searchValue={comuneResidenza?.label}
										OnChange={(newValue, option: any) => {
											form.setFieldsValue({
												ComuneResidenza: option,
											});
											OnSelectComuneResidenza(option);
										}}
									/>
								</Form.Item>
							</div>

							<div>
								<Label text={" *" + t("assistito.form.CAP.Residenza")} />
								<Form.Item name="CapComuneResidenza" rules={[{ required: true, message: t("assistito.requiredMessages.CAP") }]}>
									<Input disabled={!needCapResidenza} placeholder={t("assistito.form.CAP.Residenza")} />
								</Form.Item>
							</div>
							{needMunicipioResidenza && (
								<div>
									<Label text={" *" + t("assistito.form.addressResidence.hamlet.name")} />
									<Form.Item name="MunicipioResidenza" rules={[{ required: true, message: t("assistito.requiredMessages.townHall") }]}>
										<Select placeholder={t("assistito.form.addressResidence.hamlet.placeholder")}>
											{municipiResidenza.map((municipio, index) => {
												return (
													<Option key={index} value={municipio.Value}>
														{municipio.Text}
													</Option>
												);
											})}
										</Select>
									</Form.Item>
								</div>
							)}
							<div>
								<Label text={t("assistito.form.addressResidence.phone.name")} />
								<Form.Item name="TelefonoResidenza">
									<Input placeholder={t("assistito.form.addressResidence.phone.placeholder")} />
								</Form.Item>
							</div>
						</>
					)}

					<AssistedPrivacyAutorizations />

					<div>
						<CustomButton
							text={t("assistito.text.confermaAssistenza")}
							style={{ width: "100%" }}
							htmlType="submit"
							buttonType={CustomButtonType.positive}
						/>
					</div>
				</Form>
			</Spin>
		</div>
	);
};
export default Enhanced(FormAssistito, { componentNamespace: "FormAssistito" });
